var _g, _defs;
const _excluded = ["svgRef"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgExamAddGray = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8006 8.9L12.4006 9.2C11.6006 9.2 10.9006 8.7 10.9006 7.9L10.6006 5.5H10.7006L14.8006 8.9Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6002 17.7001C15.7002 18.5001 15.1002 19.2001 14.4002 19.2001L6.9002 20.0001H6.8002H6.6002C5.8002 20.1001 5.1002 19.5001 5.1002 18.8001L4.0002 7.6001C3.9002 6.8001 4.5002 6.1001 5.2002 6.1001L10.5002 5.6001H10.6002L10.8002 7.9001C10.8002 8.1001 10.9002 8.3001 11.0002 8.4001C11.1002 8.5001 11.2002 8.7001 11.3002 8.8001C11.6002 9.1001 12.0002 9.2001 12.4002 9.2001H12.6002H12.7002L14.7002 9.0001L15.6002 17.7001Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3998 8.9001L14.8998 9.0001H14.7998L12.9998 9.2001C12.8998 9.2001 12.7998 9.2001 12.7998 9.2001C12.0998 9.2001 11.5998 8.6001 11.4998 8.0001L11.2998 6.1001V6.0001V5.6001H11.3998L15.3998 8.9001Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5998 17.7001C15.6998 18.5001 15.0998 19.2001 14.3998 19.2001L6.89981 20.0001C6.29981 19.9001 5.69981 19.4001 5.69981 18.8001L4.59981 7.6001C4.49981 6.8001 5.09981 6.1001 5.79981 6.1001L10.5998 5.6001H10.6998H10.9998H11.0998V6.0001V6.1001L11.2998 7.9001C11.3998 8.6001 11.8998 9.1001 12.5998 9.1001C12.6998 9.1001 12.7998 9.1001 12.7998 9.1001L14.7998 9.0001L15.5998 17.7001Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 8.3H15.3002C14.4002 8.3 13.7002 7.6 13.7002 6.7V4L13.8002 4.1L18.0002 8.3Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0004 8.3V18.4C18.0004 19.3 17.3004 20 16.4004 20H7.50039C6.60039 20 5.90039 19.3 5.90039 18.4V5.6C5.90039 4.7 6.60039 4 7.50039 4H13.6004H13.7004V6.7C13.7004 7.6 14.4004 8.3 15.3004 8.3H18.0004Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 8.3V18.4C18.0002 19.3 17.3002 20 16.4002 20H8.3002C7.4002 20 6.7002 19.3 6.7002 18.4V5.6C6.7002 4.7 7.4002 4 8.3002 4H13.6002H13.7002V6.7C13.7002 7.6 14.4002 8.3 15.3002 8.3H18.0002Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 11H9.5C9.2 11 9 10.8 9 10.5C9 10.2 9.2 10 9.5 10H15.4C15.7 10 15.9 10.2 15.9 10.5C15.9 10.8 15.6 11 15.4 11Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 14H9.5C9.2 14 9 13.8 9 13.5C9 13.2 9.2 13 9.5 13H15.4C15.7 13 15.9 13.2 15.9 13.5C15.9 13.8 15.6 14 15.4 14Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8 16.6001H9.5C9.2 16.6001 9 16.4001 9 16.1001C9 15.8001 9.2 15.6001 9.5 15.6001H12.8C13.1 15.6001 13.3 15.8001 13.3 16.1001C13.3 16.4001 13.1 16.6001 12.8 16.6001Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9996 16.8001C19.9996 18.6001 18.4996 20.0001 16.7996 20.0001C15.0996 20.0001 13.5996 18.5001 13.5996 16.8001C13.5996 15.1001 15.0996 13.6001 16.7996 13.6001C18.4996 13.6001 19.9996 15.0001 19.9996 16.8001Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3994 17.3001H14.9994C14.6994 17.3001 14.3994 17.0001 14.3994 16.7001C14.3994 16.4001 14.6994 16.1001 14.9994 16.1001H18.3994C18.6994 16.1001 18.9994 16.4001 18.9994 16.7001C18.9994 17.0001 18.6994 17.3001 18.3994 17.3001Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1992 18.3999V14.9999C16.1992 14.6999 16.4992 14.3999 16.7992 14.3999C17.0992 14.3999 17.3992 14.6999 17.3992 14.9999V18.3999C17.3992 18.6999 17.0992 18.9999 16.7992 18.9999C16.3992 18.8999 16.1992 18.6999 16.1992 18.3999Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 10.6572,
    y1: 9.19997,
    x2: 12.4714,
    y2: 7.46434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 15.2146,
    y1: 4.49805,
    x2: 7.62584,
    y2: 15.2495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExamAddGray, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ExamAddGray.882b0943.svg";
export { ForwardRef as ReactComponent };